import React from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';

import { reactPlugin } from 'app-insights';

import { TakeMeHomeButton } from 'components/Buttons';

import styles from './NotFound.module.scss';

const NotFound = () => (
  <div className={styles.background_layer}>
    <div className={styles.gradient_layer} />
    <div className={styles.container}>
      <h1 className={styles.header}>404</h1>
      <div className={styles.description}>Sorry, that page doesn't exist or is unavailable.</div>
      <TakeMeHomeButton className={styles.button} centered />
    </div>
  </div>
);

export default withAITracking(reactPlugin, NotFound, 'NotFoundPage');
